import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { TailSpin } from "react-loader-spinner";
import {
  RECUPERE_SOUSCRIPTION,
  RECUPERER_FORFAIT,
  SOUSCRIRE,
} from "../../Utils/constant";
import { find, store } from "../../services/service";

export const AfficherSouscription = ({ numeroTicket, handleNext }) => {
  const [forfait, setForfait] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [msg, setMsg] = useState(null);
  const [souscription, setSouscription] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const submit = (data) => {
    setIsSubmit(true);
    store(
      `${SOUSCRIRE}/${forfait?.forfait?.id}?numeroSouscription=${data.numero}&numeroTicket=${numeroTicket}`,
      "application/json",
      {},
    )
      .then((res) => {
        if (res.status === 200) {
          setIsSubmit(null);
          toast.success("Souscription éffectuée");
          setSouscription(res?.data?.donnee);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setMsg(err?.response?.data?.donnee);
      });
  };

  useEffect(() => {
    find(`${RECUPERE_SOUSCRIPTION}?numeroTicket=${numeroTicket}`)
      .then((res) => {
        setSouscription(res?.data?.donnee);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    find(`${RECUPERER_FORFAIT}?numeroTicket=${numeroTicket}`)
      .then((res) => {
        setForfait(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response.data);
        setLoading(false);
      });
  }, []);

  return (
    <>
      {isSubmit === null || souscription ? (
        <div className="p-3 rounded-lg">
          <div className="px-4 sm:px-0">
            <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
              Souscription
            </h1>
            <p className="lg:text-lg text-2xl text-gray-900">
              Information sur le forfait du client
            </p>
          </div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Forfait
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  {souscription?.designation ?? "--"}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Description du forfait
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  {souscription?.description ?? "--"}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      ) : souscription !== true && loading === false ? (
        <div className="p-3 rounded-lg">
          <div className="px-4 sm:px-0">
            <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
              Souscription
            </h1>
            <p className="lg:text-lg text-2xl text-gray-900">
              Information sur le forfait du client
            </p>
            {msg && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                <div className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5 text-red-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p className="text-sm text-red-700 font-medium">{msg}</p>
                </div>
              </div>
            )}
          </div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Forfait
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  {forfait?.forfait?.designation ?? "--"}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Categorie
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                  {forfait?.forfait?.categorie
                    ?.replace("_", "")
                    .toLowerCase() ?? "--"}
                </dd>
              </div>

              {/* <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Code de souscription
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                  {forfait?.codeSouscription ?? "--"}
                </dd>
              </div> */}

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Montant de la souscription
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                  {forfait?.equipement?.cout ?? "--"}
                </dd>
              </div>
            </dl>
          </div>
          <form onSubmit={handleSubmit(submit)}>
            <div className="my-2">
              <label htmlFor="" className="text-sm font-medium">
                Numero FTTH <span className="text-red-500">*</span>
              </label>
              <input
                {...register("numero", { required: true })}
                type="number"
                min={0}
                defaultValue={forfait?.numeroFtth.replace(/@mtn.ci/g, "")}
                placeholder=""
                className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                // readOnly
              />
              {errors.numero && (
                <span className="text-sm text-rose-600">
                  Ce champs est obligatoire
                </span>
              )}
            </div>

            <button
              type="submit"
              disabled={isSubmit ? true : false}
              className={`${
                !isSubmit
                  ? "text-black bg-main"
                  : "text-slate-800 bg-slate-200 "
              } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
            >
              {!isSubmit ? "Souscrire au forfait" : "Veuillez patientez..."}{" "}
              {isSubmit ? (
                <span className="loading loading-dots loading-xs"></span>
              ) : null}
            </button>
          </form>
        </div>
      ) : (
        <div className="w-full my-4 flex items-center justify-center">
          <TailSpin
            height="40"
            width="40"
            color="#000"
            ariaLabel="tail-spin-loading"
            radius="2"
            wrapperStyle={{}}
            wrapperClass=""
            visible={loading}
          />
        </div>
      )}

      {error ? (
        <p className="my-3 text-sm text-red-600">{error?.donnee}</p>
      ) : null}

      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <span
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={handleNext}
          >
            Poursuivre
          </span>
        </div>
      </div>
    </>
  );
};
